<template>
  <div class="wrapper">
    <div class="right-header">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="crumbs">
        <el-breadcrumb-item v-for="(item) in navStr"
                            :key="item.id"
                            :to="'/home/contract?id='+item.id + '&name='+item.name+'&system=4'">
          {{ item.name }}
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <span class="goBtn" @click="prev">返回</span>
      </div>
    </div>


    <div class="contract-list padding-sm">

      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center">
          <el-date-picker
            class="margin-right-sm"
            style="width: 200px;"
            v-model="searchYear"
            type="year"
            placeholder="请选择年份">
          </el-date-picker>
          <el-input v-model="searchName" class="margin-right-sm" style="width: 200px;"
                    placeholder="请输入关键词"></el-input>
          <el-button type="primary" @click="getList">搜索</el-button>
        </div>
        <el-button type="warning" @click="addContract">添加合同</el-button>
      </div>


      <div class="contract-month" v-if="other.length>0">
        <h3>待完善合同</h3>
        <ul class="flex align-center flex-wrap">
          <li v-for="item in other" :key="item.id" @click="toEdit(item.id)">
            <div class="active ovDna">{{ item.name }}</div>
            <div>编号：{{ item.number }}</div>
            <div>类型：{{ item.type | type }}</div>
            <div>密级：{{ item.leave | leave }}</div>
            <div>时间：{{ item.start_time }} ～ {{ item.end_time }}</div>
            <div>金额：{{ item.money }}元</div>
          </li>
        </ul>
      </div>
      <div class="contract-month" v-for="item in list" :key="item.date">
        <h3>{{ item.date }}</h3>
        <ul class="flex align-center flex-wrap">
          <li v-for="items in item.list" :key="items.id" @click="toEdit(items.id)">
            <div class="active ovDna">{{ items.name }}</div>
            <div>编号：{{ items.number }}</div>
            <div>类型：{{ items.type | type }}</div>
            <div>密级：{{ items.leave | leave }}</div>
            <div>时间：{{ items.start_time }} ～ {{ items.end_time }}</div>
            <div>金额：{{ items.money }}元</div>
          </li>
        </ul>
      </div>
    </div>


  </div>
</template>

<script>
import {contractLevel, contractType, filesCN, zhDate} from "@/tools/utils";

export default {
  name: "contractList",
  data() {
    return {
      navStr: [],
      searchYear: '',
      searchName: '',
      list: [],
      other: []
    }
  },
  created() {
    this.getList()
    this.NowTab()
  },
  components: {},
  methods: {
    //  修改合同
    toEdit(id) {
      this.$router.push('/home/contractDetail?id=' + this.$route.query.id + '&cid=' + this.$route.query.cid + '&htid=' + id)
    },
    //  新建合同
    addContract() {
      this.$prompt('请输入合同标题', '新增合同', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        if (value) {
          this.submitContractTitle(value)
        } else {
          this.$message.error('未填写合同标题')
        }
      })
    },
    submitContractTitle(str) {
      this.$api.apiContent
        .addOrUpdateContract({
          mid: this.$store.state.userMid,
          name: str,
        })
        .then(res => {
          this.$router.push('/home/contractDetail?id=' + this.$route.query.id + '&cid=' + this.$route.query.cid + '&htid=' + res.data)
        })
    },
    //  获取当前文件或文件夹的导航
    NowTab() {
      this.$api.apiContent
        .NowTab({
          mid: this.$store.state.userMid,
          FileId: this.$route.query.cid
        })
        .then(res => {
          this.KuName = res.data[0].name;
          this.navName = "";
          this.navStr = [];
          var data = res.data;
          for (var i = 0; i < data.length; i++) {
            if (data[i].name) {
              this.navStr.push(data[i])
              continue
            }
            this.navStr.push(
              {"name": data[i].label, "id": data[i].id}
            )
          }
          // res.data.map(item => {
          // this.navStr += item.name
          //   ? '<span @click="goUrl()">' + item.name + "</span>" + " > "
          //   : '<span @click="goUrl2()">' + item.label + "</span>" + " > ";
          // });
          // this.navName = this.navName.substring(0, this.navName.length - 2);
          // this.navStr = this.navStr.substring(0, this.navStr.length - 2);
        });
    },
    //  获取合同列表
    getList() {
      this.$api.apiContent
        .contractList({
          mid: this.$store.state.userMid,
          searchName: this.searchName,
          year: zhDate(new Date(this.searchYear),4),
        })
        .then(res => {
          this.list = res.data.list
          this.other = res.data.other
        });
    },
    //  返回
    prev() {
      this.$router.go(-1);
      this.$store.state.upTree = true;
    },
  },
  filters: {
    type(val) {
      return filesCN(Number(val), contractType)
    },
    leave(val) {
      return filesCN(Number(val), contractLevel)
    }
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.wrapper {

  .right-header {
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    b {
      font-size: 18px;
      padding-right: 5px;
    }

    .crumbs {
      font-size: 18px;
      line-height: 30px;
    }

    .goBtn {
      display: block;
      height: 42px;
      line-height: 42px;
      width: 60px;
      text-align: center;
      border-radius: 6px;
      cursor: pointer;
      background: #0a2240;
      color: #ffffff;
    }
  }

  .contract-list {
    .contract-month {
      position: relative;

      h3 {
        font-size: 18px;
        color: #0a2240;
        font-weight: bold;
        padding-left: 20px;

        &:before {
          position: absolute;
          top: 0;
          left: 0;
          content: '';
          width: 15px;
          height: 15px;
          border-radius: 15px;
          background: #0a2240;
        }

        &:after {
          position: absolute;
          top: 10px;
          left: 8px;
          bottom: 0;
          content: '';
          width: 1px;
          background: #0a2240;
        }
      }

      ul {
        padding: 30px 30px 30px 50px;

        li {
          border: 1px solid #0a2240;
          padding: 10px;
          border-radius: 5px;
          margin: 0 20px 20px 0;
          width: 270px;
          height: 215px;
          box-shadow: 0 10px 10px #0a2240;
          cursor: pointer;

          &:hover {
            background: #0a2240;
            color: #fff;

            div {
              &.active {
                color: #ffb400;
              }
            }
          }

          div {
            font-size: 16px;
            line-height: 32px;

            &.active {
              font-size: 18px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
</style>
